import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
} from '@angular/forms'
import { MessageService } from 'primeng/api'
import { ReportsService, ReportParamService } from '../../../../../api/services'
import { ReportsCategoryComponent } from '../../reports-category/reports-category.component'
import { Router, ActivatedRoute } from '@angular/router'
import { Globalattributes } from '../../../../../api/models'
import { validateAllFormFields } from '../../../../../formUtils'

@Component({
  selector: 'app-reportparam-edit',
  templateUrl: './reportparam-edit.component.html',
  styleUrls: ['./reportparam-edit.component.css'],
})
export class ReportparamEditComponent implements OnInit {
  globalattributelist: Globalattributes[]
  editparamreport
  errorValidationSummary: string = ''
  reportparamId: number
  reportId: number
  reportName: string
  ShowErrorSummary: boolean = false
  datatypes: { type: string; value: string }[]
  datatypesControl = new UntypedFormControl()
  stringdatatype: boolean = false
  numberdatatype: boolean = false
  datedatatype: boolean = false
  datetimedatatype: boolean = false
  timedatatype: boolean = false
  currencydatatype: boolean = false
  booleandatatype: boolean = false
  isglobalattribute: boolean = false
  isdatatypeattribute: boolean = true
  constructor(
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private reportparamservice: ReportParamService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    debugger
    this.activatedRoute.queryParams.subscribe((params) => {
      let data = params
      this.reportId = data.report_Id
      this.reportName = data.report_Name
      this.reportparamId = data.reportparam_Id
    })
    this.datatypes = [
      { type: 'Number', value: '0' },
      { type: 'String', value: '1' },
      { type: 'Date', value: '2' },
      { type: 'Boolean', value: '3' },
      { type: 'Currency', value: '4' },
      { type: 'DateTime', value: '5' },
      { type: 'Time', value: '6' },
    ]

    this.editparamreport = this.fb.group({
      reportName: [this.reportName, Validators.required],
      reportparamshortnote: ['', Validators.required],
      reportparamname: ['', Validators.required],
      isrequired: new UntypedFormControl(null, []),
      picklistValues: new UntypedFormControl('', []),
      datatype: new UntypedFormControl('', []),
      defaultvalue: new UntypedFormControl('', []),
      displayieldName: new UntypedFormControl('', []),
      endDateTime: new UntypedFormControl('', []),
      endTime: new UntypedFormControl('', []),
      isLookUp: new UntypedFormControl(null, []),
      maxCurrency: new UntypedFormControl('', []),
      maxdate: new UntypedFormControl('', []),
      maxnumber: new UntypedFormControl('', []),
      maxstringlength: new UntypedFormControl(null, []),
      minCurrency: new UntypedFormControl('', []),
      mindate: new UntypedFormControl('', []),
      minnumber: new UntypedFormControl('', []),
      startDateTime: new UntypedFormControl('', []),
      startTime: new UntypedFormControl('', []),
      tableName: new UntypedFormControl('', []),
      valueColumnName: new UntypedFormControl('', []),
    })

    this.LoadglobalAttributes()
  }


    //LoadglobalAttributes(): void {
    //this.reportparamservice
    //  .reportParamGetglobalattributes({})
    //  .subscribe((result) => {
    //      this.globalattributelist = result.globalattributesSettings

    //    this.patchdefaultValues()
    //  })
    //}

    LoadglobalAttributes(): void {
        this.reportparamservice
            .reportParamGetglobalattributes({})
            .subscribe((result) => {
                this.globalattributelist = result.globalattributesSettings
                this.patchdefaultValues()
            })
    }


    //LoadglobalAttributes(): void {      
    //    this.reportparamservice.reportParamGetglobalattributes({})
    //        .subscribe((result: { globalattributesSettings?: Array<Globalattributes> | null }) =>
    //        {
    //            if (result.globalattributesSettings) {
    //                this.globalattributelist = result.globalattributesSettings.map(item => ({ ...item, settingName: item.settingName ? item.settingName : null }));
    //            } else
    //            {
    //                this.globalattributelist = null;
    //            }
    //            this.patchdefaultValues();
    //        });
    //}


    private formatSettingName(name: string): string
    {
       
        return name.replace(/([a-z])([A-Z])/g, '$1 $2');
        

       


    }
  patchdefaultValues() {
    this.reportparamservice
      .reportParamGetRecord({
        reportParamId: this.reportparamId,
      })
      .subscribe((data) => {
        if (data) {
          this.editparamreport.updateValueAndValidity()
          this.editparamreport.patchValue(data)
          this.editparamreport.controls.picklistValues.setValue({
            settingValue: data.picklistValues,
          })
          this.editparamreport.controls.datatype.setValue({
            value: data.datatype,
          })
          this.setAttributes()
        }
      })
  }
  setAttributes() {
    debugger
    if (this.editparamreport.value.isrequired) {
      this.isglobalattribute = true
      this.isdatatypeattribute = false
      this.stringdatatype = false
      this.numberdatatype = false
      this.datetimedatatype = false
      this.timedatatype = false
      this.datedatatype = false
      this.currencydatatype = false
    } else {
      this.isdatatypeattribute = true
      this.isglobalattribute = false
      this.SetDatatypeControls()
    }
  }
  SetDatatypeControls() {
    this.stringdatatype = false
    this.numberdatatype = false
    this.datetimedatatype = false
    this.timedatatype = false
    this.datedatatype = false
    this.currencydatatype = false
    debugger
    switch (this.editparamreport.value.datatype.value) {
      case '0':
        this.numberdatatype = true
        break
      case '1':
        this.stringdatatype = true

        break
      case '2':
        this.datedatatype = true
        break
      case 'Boolean':
        break
      case '4':
        this.currencydatatype = true
        break
      case '5':
        this.datetimedatatype = true
        break
      case '6':
        this.timedatatype = true
        break
      default:
        console.log('No case exists!')
        break
    }
  }
  updateParamReport() {
    validateAllFormFields(this.editparamreport)
    if (this.editparamreport.invalid) {
      return
    }
    debugger
    if (this.editparamreport.value.picklistValues != '') {
      this.editparamreport.value.picklistValues =
        this.editparamreport.value.picklistValues.settingValue + ''
    } else {
      this.editparamreport.value.picklistValues = ''
    }
    if (this.editparamreport.value.datatype != '') {
      this.editparamreport.value.datatype =
        this.editparamreport.value.datatype.value
    } else {
      this.editparamreport.value.datatype = ''
    }

    debugger
    this.reportparamservice
      .reportParamPut({
        id: this.reportparamId,
        rptid: this.reportId,
        body: this.editparamreport.value,
      })
      .subscribe(
        (val) => {
          if (val) {
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              summary: 'Confirmation',
              detail: `Report param  updated successfully `,
              life: 5000,
            })
          }
          this.router.navigate(['administration/reports-param'], {
            queryParams: {
              report_Id: this.reportId,
              report_Name: this.reportName,
            },
            skipLocationChange: true,
          })
        },
        (err) => {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: 'ERROR',
            detail: `error  in updating param `,
            life: 5000,
          })

          //console.log(err.error);
        },
      )
  }

  navigateToParamList(): void {
    debugger
    this.router.navigate(['administration/reports-param'], {
      queryParams: { report_Id: this.reportId, report_Name: this.reportName },
      skipLocationChange: true,
    })
  }
}
